import React from 'react';
import PropTypes from 'prop-types';

import HeaderActions from './actions'
import style from './index.module.scss';

function TopicHeader({ topic }) {
  return (
    <header className={`row ${style.header}`}>
      <div className={`col-2 ${style['col-image']}`}>
        <img src={topic.imgUrl} alt={topic.name} className={style['topic-image']} />
      </div>
      <div className={`col-10 ${style['topic-info']}`}>
        <p className={style['topic-name']}>{topic.name}</p>
        <div className={`${style['topic-actions']} ${style['topic-actions--large']}`}>
          <HeaderActions topic={topic} />
        </div>
      </div>
      <div className={`${style['topic-actions']} ${style['topic-actions--mobile']}`}>
        <HeaderActions topic={topic} />
      </div>
    </header>
  )
}

TopicHeader.propTypes = {
  topic: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    imgUrl: PropTypes.string.isRequired,
    followedBy: PropTypes.array.isRequired,
  }),
};

export default TopicHeader;
